const model = {
    unitDetails: null,
    loading: false,
    error: null,
};

export default model;
